import { CustomDataFormPage } from "~/pages/CustomDataFormPage";
import { dateOptions } from "~/pages/DataFormPage";
import { queryClient, trpc } from "~/utils/trpc";
import { createFileRoute } from "@tanstack/react-router";
import dayjs from "dayjs";
import { z } from "zod";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";

const translateTime = (t: string, type: "Date" | "TimeStamp") => {
  const format = type === "Date" ? "YYYY-MM-DD" : "YYYY-MM-DD HH:mm";
  if (dateOptions.find((item) => item.value === t)) {
    if (t === "same_day") {
      return dayjs().format(format);
    }
    const date = t.split("_");
    if (date.length < 3) {
      return dayjs().format(format);
    }
    const unit = z.enum(["day", "week", "month"]).safeParse(date[1]);
    if (!unit.success) return dayjs().format(format);
    if (date[2] === "before") {
      return dayjs().subtract(Number(date[0]), unit.data).format(format);
    }
    if (date[2] === "after") {
      return dayjs().add(Number(date[0]), unit.data).format(format);
    }
    return dayjs().format(format);
  }
};

export const Route = createFileRoute("/_dashboard/$datasetSlug/data/custom/details/$id/create")({
  component: RouteComponent,
  loader: async ({ params }) => {
    const id = params.id;
    const entity = await queryClient.fetchQuery(trpc.customEntities.getCustomEntitiesById.queryOptions({ id: id }));
    const data: Record<string, unknown> = {};
    if (entity?.attributes) {
      for (const item of entity.attributes) {
        if (item.type === "Date" || item.type === "TimeStamp") {
          data[item.id] =
            typeof item.defaultValue === "string" ? translateTime(item.defaultValue, item.type) : undefined;
          continue;
        }
        data[item.id] = item.defaultValue;
      }
    }
    return { entity, data, id };
  },
});

function RouteComponent() {
  const { id } = Route.useParams();
  const { entity, data } = Route.useLoaderData();
  useBreadCrumbs([
    {
      title: `${entity?.p_name || entity?.name}`,
      link: `/${location.pathname.split("/")[1]}/data/custom/details/${id}/table`,
    },
    { title: "Create", link: `/${location.pathname.split("/")[1]}/data/custom/details/${id}/create` },
  ]);

  return (
    <div className="mx-5 pb-4">
      <h1 className="text-2xl font-bold mb-6">Create {entity?.name}</h1>
      <div className="[&_.max-w-2xl]:max-w-full! [&_.mx-auto]:mx-0! [&>div]:mx-0!">
        <CustomDataFormPage entity={entity} data={data} id={id} hideHeader={true} />
      </div>
    </div>
  );
}
